<div class="schedule-view" *ngIf="assetsAndSchedules.length">
  <div class="grid-container" [attr.style]="
      '--grid-cols: ' + numberOfMainColumns +
      '; --grid-rows: ' + numberofMainRows +
      '; --grid-col-divisions: ' + (subdivisionsPerColumn * hoursPerColumn) | safestyle">

    <div class="basic-grid">
      <ng-container>
        <div class="left-heading-cell"></div>
        <div class="top-heading-cell" *ngFor="let day of days">{{ day }}</div>
      </ng-container>
      <ng-container>
        <div class="left-heading-cell"></div>
        <div class="top-subheading-cell" *ngFor="let hour of hours">{{ hour.label }}</div>
      </ng-container>
      <ng-container *ngFor="let asset of assetsAndSchedules">
        <div class="left-heading-cell">
          <a *ngIf="!isWorker" [routerLink]="['/', routeRole, 'sites', siteId, 'assets', asset.id]">
            {{ asset.name }}
          </a>
          <span *ngIf="isWorker">
            {{ asset.name }}
          </span>
        </div>
        <div class="empty-scheduler-cell" *ngFor="let hour of hours; let i = index" (click)="onGridClick(asset.id, hour.date)">
          <div class="empty-scheduler-cell-inner" [class.firstCol]="i === 0" [class.lastCol]="i === (hours.length - 1)"></div>
        </div>
      </ng-container>
    </div>

    <div class="booking-grid">
      <div
        *ngFor="let booking of bookings"
        class="booking-box"
        [attr.style]="
            '--border: ' + (booking.booking.displayOrder > 0 ? '1px solid black' : 'none') +
            '; --display-order: ' + (booking.booking.status === 'PENDING' ? '' : '-') + (booking.booking.displayOrder) +
            '; grid-column: ' + booking.graphDetails.columnStart + ' / span ' + booking.graphDetails.columnSpan +
            '; grid-row: ' + booking.graphDetails.rowStart + ' / span ' + booking.graphDetails.rowSpan | safestyle"
        [ngClass]="booking.graphDetails.extraClasses"
        [ngStyle]="{'z-index': 20 - booking.booking.displayOrder }"
        (click)="onBookingClick(booking)"
      >
        <div class="booking-box-inner" [ngbTooltip]="booking.booking.reason" placement="bottom"></div>
      </div>
    </div>

  </div>
</div>
